/** @format */

export const paths = {
  index: '/',
  checkout: '/checkout',
  contact: '/contact',
  pricing: '/pricing',
  auth: {
    login: '/auth/login',
    forgot: '/auth/forgot',
    register: '/auth/register',
    otp: '/auth/otp'
  },
  authDemo: {
    forgotPassword: {
      classic: '/auth-demo/forgot-password/classic',
      modern: '/auth-demo/forgot-password/modern'
    },
    login: {
      classic: '/auth-demo/login/classic',
      modern: '/auth-demo/login/modern'
    },
    register: {
      classic: '/auth-demo/register/classic',
      modern: '/auth-demo/register/modern'
    },
    resetPassword: {
      classic: '/auth-demo/reset-password/classic',
      modern: '/auth-demo/reset-password/modern'
    },
    verifyCode: {
      classic: '/auth-demo/verify-code/classic',
      modern: '/auth-demo/verify-code/modern'
    }
  },
  management: {
    overview: '/management/overview',
    analytic: '/management/analytic',
    schedule: '/management/schedule',
    dashboard: '/management/dashboard',
    control: '/management/control',
    event: '/management/event',
    diagnostic: '/management/diagnostic',
    car: {
      index: '/management/car',
      create: '/management/car/new',
      edit: '/management/car/:carId/edit',
      detail: '/management/car/:carId'
    },
    user: {
      index: '/management/user'
    },

    // diagnosticChart: "/management/diagnostic/:diagnosticId",
    report: '/management/report',
    alarm: '/management/alarm'
  },
  booking: {
    list: 'booking'
  },
  configuration: {
    index: '/',
    basicCost: '/configuration/cost/basic',
    operatingCost: '/configuration/cost/operating',
    carBrand: '/configuration/car/brand',
    carModel: '/configuration/car/model',
    carFeature: '/configuration/car/feature',
    carSpecification: '/configuration/car/specification'
  },
  administrator: {
    customerManagement: '/administrator/customer-management',
    userManagement: '/administrator/user-management'
  },
  account: {
    index: '/account',
    userManagement: '/user-management',
    complete: '/account/complete'
  },
  about: {
    index: '/about'
    // userManagement: '/user-management',
  },
  dashboard: {
    index: '/',
    academy: {
      index: '/academy',
      courseDetails: '/academy/courses/:courseId'
    },
    account: '/account',
    analytics: '/analytics',
    blank: '/blank',
    blog: {
      index: '/blog',
      postDetails: '/blog/:postId',
      postCreate: '/blog/create'
    },
    calendar: '/calendar',
    chat: '/chat',
    crypto: '/crypto',
    customers: {
      index: '/customers',
      details: '/customers/:customerId',
      edit: '/customers/:customerId/edit'
    },
    ecommerce: '/ecommerce',
    fileManager: '/file-manager',
    invoices: {
      index: '/invoices',
      details: '/invoices/:orderId'
    },
    jobs: {
      index: '/jobs',
      create: '/jobs/create',
      companies: {
        details: '/jobs/companies/:companyId'
      }
    },
    kanban: '/kanban',
    logistics: {
      index: '/logistics',
      fleet: '/logistics/fleet'
    },
    mail: '/mail',
    orders: {
      index: '/orders',
      details: '/orders/:orderId'
    },
    products: {
      index: '/products',
      create: '/products/create'
    },
    social: {
      index: '/social',
      profile: '/social/profile',
      feed: '/social/feed'
    }
  },
  components: {
    index: '/components',
    dataDisplay: {
      detailLists: '/components/data-display/detail-lists',
      tables: '/components/data-display/tables',
      quickStats: '/components/data-display/quick-stats'
    },
    lists: {
      groupedLists: '/components/lists/grouped-lists',
      gridLists: '/components/lists/grid-lists'
    },
    forms: '/components/forms',
    modals: '/components/modals',
    charts: '/components/charts',
    buttons: '/components/buttons',
    typography: '/components/typography',
    colors: '/components/colors',
    inputs: '/components/inputs'
  },
  docs: 'https://material-kit-pro-react-docs.devias.io',
  401: '/401',
  404: '/404',
  500: '/500'
};
